// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "NotFound" + "." + "c0e00b8c" + ".css";
};